(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('chat-message', {
            parent: 'entity',
            url: '/chat-message?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.chatMessage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat-message/chat-messages.html',
                    controller: 'ChatMessageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chatMessage');
                    $translatePartialLoader.addPart('deliveredStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('chat-message-detail', {
            parent: 'chat-message',
            url: '/chat-message/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.chatMessage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat-message/chat-message-detail.html',
                    controller: 'ChatMessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chatMessage');
                    $translatePartialLoader.addPart('deliveredStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChatMessage', function($stateParams, ChatMessage) {
                    return ChatMessage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'chat-message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('chat-message-detail.edit', {
            parent: 'chat-message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat-message.new', {
            parent: 'chat-message',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                imageUrl: null,
                                readStatus: false,
                                solved: false,
                                replyMessageId: null,
                                telegramMessageId: null,
                                deliveredStatus: null,
                                errorMessage: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('chat-message');
                });
            }]
        })
        .state('chat-message.edit', {
            parent: 'chat-message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat-message.delete', {
            parent: 'chat-message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-delete-dialog.html',
                    controller: 'ChatMessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
